import { DateTimePicker } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { TellescopeFormFieldBaseProps } from "../types";

export interface DateFieldProps extends TellescopeFormFieldBaseProps<"date"> {}

export const DateField = ({ title, value, onChange, className, error, onBlur, touched }: DateFieldProps) => {
  const showError = !!(error && touched);

  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <DateTimePicker
        value={value}
        onChange={onChange}
        onClose={onBlur}
        className={cn(className, showError && "border-destructive")}
        label=""
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
